import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import ApiUrls from "../../../Utils/axr";
import { errorConditionGTM } from "../../../Utils/googleTags";

type WifiExtenderContentState = {
    WifiExtenderContent: any;
    loading: boolean;
    error: any;
}

const initialState: WifiExtenderContentState = {
    WifiExtenderContent: null,
    loading: false,
    error: null,
};

const host = window?.location?.host;
const file = "wifi-extender-content.json";

export const getWifiExtenderContent = createAsyncThunk(
    "get/wifi-extender/content",
    async () => {
        try {
            const response = await useFetchAemBrspdContents({
                [ApiUrls.aem_content]: `${file}?appName=${host}`,
            });
            return response?.data;
        } catch (error) {
            throw error;
        }
    }
);

const WifiExtenderSlice = createSlice({
    name: "wifi-extender-content/Details",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getWifiExtenderContent.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(getWifiExtenderContent.fulfilled, (state, action) => {
            state.WifiExtenderContent = action.payload;
            state.loading = false;
            state.error = null;
        })
        builder.addCase(getWifiExtenderContent.rejected, (state, action) => {
            errorConditionGTM(
                "BRSPD_Fiber_EC_Flow",
                "WifiExtender-content",
                action?.error?.message,
                action?.type
            );
            state.WifiExtenderContent = null;
            state.loading = false;
            state.error = action.error;
        });
    },
});

export default WifiExtenderSlice.reducer;